<div class="flex flex-col items-center gap-4 pb-2" [class]="direction"
  [ngClass]="isDesktop ? 'w-[30.25rem]' : 'w-full'">
  <!--
    a11y: top close (X) button, FIRST in DOM and [focusInitial]=true so the
    CDK focus trap puts initial focus here on open (audit requirement).
    Dismissing without Allow/Don't-allow returns `undefined` from closeCard,
    which the caller can treat as "user cancelled" — same as Esc.
  -->
  <div class="w-full !flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>
  <!--
    a11y: decorative illustration; the heading immediately below already conveys
    the same information ("Allow use of location" / "Permission denied").
  -->
  <img src="../../../../../assets/images/allow-location.svg" alt="" aria-hidden="true" class="w-[8rem]">
  <div class="flex flex-col gap-2 items-center">
    <h2 class="m-0 font-semibold text-xl">{{isPermissionDenied ? locationPermissionDeniedText : allowUseLocationText}}</h2>
    @if (!isPermissionDenied) {
      <p class="m-0 font-normal text-base text-center">{{allowUseLocationDescText}}</p>
    }
  </div>
  <div class="flex w-full gap-4 justify-center" [ngClass]="{'flex-col' : isMobile}">
    @if (!isPermissionDenied) {
      <mot-button [text]="allowText" buttonClass="!bg-primary !text-white !w-full !rounded-lg !align-middle"
        (onClick)="handleClick(true)" [ngClass]="isDesktop ? '!w-[13.625rem]' : 'w-full'" />
    }
    <mot-button [text]="isPermissionDenied ? okButtonText : dontAllowText"
      buttonClass="!border !border-solid !border-[#B4BFCB] !w-full !rounded-lg !align-middle"
      (onClick)="handleClick(false)" [ngClass]="isDesktop ? '!w-[13.625rem]' : 'w-full'" />
    </div>
  </div>
